import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M40.693 34.902c.362.128.624.447.678.828l.821 5.854a1.03 1.03 0 0 1-2.037.286l-.735-5.234-3.715-1.302a12.35 12.35 0 0 1-2.819 4.366c-2.337 2.337-5.432 3.625-8.716 3.625-5.272 0-9.77-3.33-11.535-7.991L8.904 36.64l-.86 5.253a1.029 1.029 0 0 1-2.03-.333l.958-5.854c.062-.372.32-.68.675-.804l4.415-1.548c-.15-.768-.234-1.56-.234-2.372v-.544H7.987a1.029 1.029 0 1 1 0-2.057h3.84v-2.998l-4.18-1.466a1.03 1.03 0 0 1-.675-.805l-.958-5.853a1.028 1.028 0 1 1 2.03-.333l.86 5.251 2.924 1.025V20.01c0-.568.46-1.03 1.028-1.03h1.323c.327-3.19 2.16-5.935 4.768-7.532a3.845 3.845 0 0 0-3.812-3.392 1.029 1.029 0 0 1 0-2.057c2.783 0 5.116 1.94 5.733 4.537a10 10 0 0 1 3.301-.57c1.094 0 2.144.182 3.13.508C27.939 7.91 30.255 6 33.016 6a1.029 1.029 0 1 1 0 2.057 3.84 3.84 0 0 0-3.796 3.287c2.7 1.58 4.607 4.376 4.94 7.638h1.323c.568 0 1.028.46 1.028 1.029v3.193l2.91-1.02.734-5.234a1.029 1.029 0 1 1 2.038.286l-.822 5.854c-.054.38-.316.7-.678.827l-4.181 1.466v2.998h3.84a1.028 1.028 0 1 1 0 2.057h-3.84v.544c0 .805-.08 1.599-.231 2.373z"
    }
  )
);
var SvgBugFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var BugFilled_default = SvgBugFilled;

export { BugFilled_default as default };
